import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './core/guards/auth.guard';
export const routes: Routes = [{
	path: 'auth',
	loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
}, {
	/** Public emailed-export download redeem — no JWT / layout shell. */
	path: 'download-positions',
	loadChildren: () =>
		import('./features/without-auth/without-auth.module').then(m => m.WithoutAuthModule),
}, {
	path: '',
	component: LayoutComponent,
	canActivate: [authGuard],
	children: [{
		path: '',
		loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
	}, {
		path: 'assistant',
		loadChildren: () => import('./features/ai-assistant/ai-assistant.module').then(m => m.AiAssistantModule)
	}, {
		path: '606-dashboard',
		loadChildren: () => import('./features/rule-606/rule-606.module').then(m => m.Rule606Module)
	}, {
		path: 'ledger',
		loadChildren: () => import('./features/ledger/ledger.module').then(m => m.LedgerModule)
	}, {
		path: 'host-services',
		loadChildren: () => import('./features/host-services/host-services.module').then(m => m.HostServicesModule),
	}, 	{
		path: 'reconciliation',
		loadChildren: () => import('./features/reconciliation/reconciliation.module').then(m => m.ReconciliationModule)
	},
	// URLs from before Reconciliation, Reconciliation Results and My Exports were merged.
	// Redirects keep query params, so bookmarked result filters and `?tab=` on job detail still work.
	{ path: 'recon-jobs', pathMatch: 'full', redirectTo: 'reconciliation/jobs' },
	{ path: 'recon-jobs/list', pathMatch: 'full', redirectTo: 'reconciliation/jobs' },
	{ path: 'recon-jobs/:jobId', pathMatch: 'full', redirectTo: 'reconciliation/jobs/:jobId' },
	{ path: 'recon-results', pathMatch: 'full', redirectTo: 'reconciliation/results' },
	{ path: 'position-exports', pathMatch: 'full', redirectTo: 'reconciliation/exports' },
	{ path: 'position-exports/list', pathMatch: 'full', redirectTo: 'reconciliation/exports' },
	{
		path: 'access-management',
		loadChildren: () => import('./features/access-management/access-management.module').then(m => m.AccessManagementModule)
	}]
}, {
	path: '**',
	redirectTo: ''
}];
@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
